import { render, staticRenderFns } from "./PushGroupsApplication.vue?vue&type=template&id=67754fc8&"
import script from "./PushGroupsApplication.vue?vue&type=script&lang=ts&"
export * from "./PushGroupsApplication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports